module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_rogaland_neg.44aa3aaa.pdf";